<template>
  <div class="home-dashboard-root h-full min-h-screen overflow-y-auto bg-[#f8fafc] dark:bg-[#0e1015] text-slate-900 dark:text-slate-100 p-4 md:p-6 lg:p-7 space-y-5 font-sans">
    <!-- 1. HEADER EXECUTIVO -->
    <div class="flex flex-col md:flex-row md:items-center justify-between gap-4 pb-1">
      <div class="flex items-center gap-3">
        <!-- Avatar Badge -->
        <div class="size-11 rounded-2xl bg-blue-50 dark:bg-[#18191f] border border-blue-200/70 dark:border-blue-500/30 text-[#2781F6] dark:text-[#60a5fa] font-bold text-sm flex items-center justify-center shadow-xs">
          {{ userInitials }}
        </div>
        <div>
          <h1 class="text-xl md:text-2xl font-bold text-slate-900 dark:text-white tracking-tight flex items-center gap-2">
            <span>{{ greetingText }}, {{ metrics.user_name || 'Vanderson' }}!</span>
            <span class="text-xl">👋</span>
          </h1>
          <div class="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400 mt-0.5 flex-wrap">
            <span>Visão Geral Executiva</span>
            <span>•</span>
            <span>Horário de Brasília {{ formattedBrasiliaDateTime }}</span>
            <span>•</span>
            <span class="inline-flex items-center gap-1.5 font-semibold text-emerald-600 dark:text-emerald-400">
              <span class="size-2 rounded-full bg-emerald-500 animate-pulse" />
              <span>Sincronizado</span>
            </span>
          </div>
        </div>
      </div>
      <!-- Ações do Header (Seletor de Funil & Atualizar) -->
      <div class="flex items-center gap-2.5 self-start md:self-auto">
        <!-- Seletor de Funil Dropdown Pill -->
        <div class="relative">
          <select
            v-if="metrics.kanban_funnels?.length"
            v-model="selectedFunnelKey"
            class="appearance-none bg-white dark:bg-[#141518] border border-slate-200 dark:border-[#26282d] text-xs font-bold text-slate-800 dark:text-slate-200 py-2 pl-7 pr-8 rounded-lg shadow-2xs cursor-pointer outline-none hover:border-[#2781F6]/50 dark:hover:border-slate-700 transition-all"
          >
            <option
              v-for="f in metrics.kanban_funnels"
              :key="f.attribute_key"
              :value="f.attribute_key"
            >
              {{ f.name }} ({{ f.total_items }})
            </option>
          </select>
          <span class="absolute left-2.5 top-1/2 -translate-y-1/2 size-2 rounded-full bg-emerald-500 pointer-events-none" />
          <span class="i-lucide-chevron-down absolute right-2.5 top-1/2 -translate-y-1/2 size-3.5 text-slate-400 pointer-events-none" />
        </div>
        <!-- Botão Atualizar -->
        <button
          @click="fetchMetrics"
          :disabled="isLoading"
          class="flex items-center gap-1.5 bg-white dark:bg-[#141518] border border-slate-200 dark:border-[#26282d] text-xs font-bold text-slate-700 dark:text-white/90 py-2 px-3.5 rounded-lg shadow-2xs hover:bg-slate-50 dark:hover:bg-[#18191f] dark:hover:border-[#2781F6]/60 hover:scale-[1.02] hover:shadow-md transition-all cursor-pointer disabled:opacity-60"
        >
          <span :class="['i-lucide-rotate-cw size-3.5 text-slate-500', isLoading ? 'animate-spin text-blue-600' : '']" />
          <span>Atualizar</span>
        </button>
      </div>
    </div>
    <!-- WIDGET EXECUTIVO: DIAGNÓSTICO SDR & TRÁFEGO SEMANAL -->
<div class="bg-gradient-to-r from-blue-50/80 via-indigo-50/50 to-white dark:from-[#161a22] dark:via-[#1a1b1e] dark:to-[#1a1b1e] border border-blue-200/80 dark:border-[#2781F6]/30 rounded-xl p-4 shadow-xs flex flex-col md:flex-row md:items-center justify-between gap-4">
  <div class="flex items-center gap-3">
    <div class="size-10 rounded-xl bg-[#2781F6]/15 border border-[#2781F6]/30 text-[#2781F6] flex items-center justify-center shrink-0">
      <span class="i-lucide-brain-circuit size-5" />
    </div>
    <div>
      <div class="flex items-center gap-2">
        <h3 class="text-xs font-black text-slate-900 dark:text-white uppercase tracking-wider">
          Diagnóstico SDR Semanal (Chat-Analyst IA)
        </h3>
        <span class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-blue-100 dark:bg-[#2781F6]/20 text-[#2781F6]">
          Últimos 7 dias
        </span>
      </div>
      <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
        {{ sdrWidget.summary?.total_leads_in || 0 }} leads entrantes • {{ sdrWidget.summary?.advancement_rate || 0 }}% avanço • Criativo destaque: <strong class="text-slate-700 dark:text-slate-200">{{ sdrWidget.top_creative?.title || 'Meta Ads' }}</strong>
      </p>
    </div>
  </div>
  <div class="flex items-center gap-3 self-end md:self-auto shrink-0">
    <router-link
      :to="{ name: 'sdr_analytics_reports' }"
      class="inline-flex items-center gap-1.5 bg-[#2781F6] hover:bg-[#1c6edb] text-white text-xs font-bold py-2 px-3.5 rounded-lg shadow-2xs hover:shadow-xs transition-all"
    >
      <span class="i-lucide-file-text size-3.5" />
      <span>Ver Relatório Completo</span>
      <span class="i-lucide-arrow-right size-3.5" />
    </router-link>
  </div>
</div>
<!-- 2. SEÇÃO FUNIL KANBAN -->
    <div class="bg-white dark:bg-[#141518] border border-slate-200/90 dark:border-[#26282d]/90 rounded-xl p-5 shadow-xs space-y-4">
      <!-- Header do Funil -->
      <div class="flex items-center justify-between flex-wrap gap-2">
        <div class="flex items-center gap-2">
          <span class="text-xs md:text-sm font-bold text-slate-900 dark:text-white uppercase tracking-wider">
            FUNIL {{ activeFunnel?.name || 'SERVIDOR' }}
          </span>
          <router-link
            :to="{ name: 'kanban_board', params: { attributeKey: activeFunnel?.attribute_key || 'servidor' } }"
            class="text-[11px] font-bold text-[#2781F6] dark:text-[#60a5fa] bg-blue-50 dark:bg-[#18191f] hover:bg-[#d9ecff] border border-[#2781F6]/20 px-2.5 py-0.5 rounded-full transition-colors inline-flex items-center gap-1"
          >
            <span>• Editar no Funil</span>
          </router-link>
        </div>
        <div class="text-xs text-slate-500 dark:text-slate-400 font-medium">
          Taxa de Conversão Geral
          <span class="text-[#2781F6] dark:text-[#60a5fa] font-bold ml-1 text-sm">
            {{ activeFunnel?.conversion_rate || '33,1' }}%
          </span>
        </div>
      </div>
      <!-- Grid Horizontal de Etapas do Funil -->
      <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
        <div
          v-for="(st, idx) in activeFunnelStages"
          :key="st.id || idx"
          @click="goToKanbanStage(activeFunnel.attribute_key, st.name)"
          class="bg-slate-50/70 dark:bg-[#101114] hover:bg-white hover:border-[#2781F6]/50 hover:scale-[1.02] hover:shadow-md dark:hover:bg-[#18191f] dark:hover:border-[#2781F6]/60 hover:scale-[1.02] hover:shadow-md border border-slate-200/70 dark:border-[#26282d] rounded-xl p-3 flex flex-col justify-between transition-all duration-200 cursor-pointer group shadow-2xs min-h-[105px] stage-card"
        >
          <!-- Topo da Etapa: Ícone + Número + Nome -->
          <div class="flex items-start gap-1.5 mb-1.5">
            <span class="p-1 rounded-md bg-white dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700 text-[#2781F6] dark:text-[#60a5fa] text-xs shrink-0">
              <span :class="getStageIcon(idx)" class="size-3.5 block" />
            </span>
            <div class="min-w-0">
              <div class="text-[10px] font-black text-slate-400 dark:text-slate-500 leading-tight">
                {{ idx + 1 }}
              </div>
              <div class="text-[11px] font-bold text-slate-800 dark:text-slate-200 truncate leading-tight group-hover:text-blue-600 dark:group-hover:text-blue-400" :title="st.name">
                {{ st.name }}
              </div>
            </div>
          </div>
          <!-- Meio: Contagem de Processos -->
          <div class="flex items-baseline gap-1 my-1">
            <span class="text-lg font-bold text-slate-900 dark:text-white leading-none">
              {{ st.count }}
            </span>
            <span class="text-[10px] text-slate-400 font-medium">processos</span>
          </div>
          <!-- Base: Barra de Progresso + % -->
          <div class="flex items-center gap-2 pt-1.5 border-t border-slate-200/50 dark:border-slate-700/40 mt-1">
            <div class="flex-1 h-2 bg-slate-200/80 dark:bg-[#18191f] rounded-full overflow-hidden">
              <div
                v-if="Number(st.count) > 0"
                class="h-full rounded-full transition-all duration-500 shadow-xs"
                :style="{
                  width: `${Math.min(Math.max(Number(st.percentage) || 33.1, 15), 100)}%`,
                  backgroundColor: '#2781F6'
                }"
              />
            </div>
            <span
              class="text-[10px] font-bold shrink-0"
              :class="Number(st.count) > 0 ? 'text-[#2781F6] dark:text-[#60a5fa]' : 'text-slate-400 dark:text-slate-500'"
            >
              {{ st.percentage || 0 }}%
            </span>
          </div>
        </div>
      </div>
    </div>
    <!-- 3. SEÇÃO FILAS DE ATENDIMENTO & CONVERSAS -->
    <div class="space-y-2.5">
      <h2 class="text-xs font-bold text-slate-900 dark:text-white uppercase tracking-wider">
        FILAS DE ATENDIMENTO & CONVERSAS
      </h2>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3.5">
        <!-- 1) AGUARDANDO RESPOSTA (Gradiente Dark Navy Blue) -->
        <div
          @click="goToConversations('unattended')"
          class="rounded-xl p-4 bg-gradient-to-br from-[#2781F6] via-[#1c6edb] to-[#1557ad]  hover:brightness-105 shadow-sm shadow-blue-500/20 text-white shadow-sm flex flex-col justify-between cursor-pointer hover:shadow-md hover:scale-[1.01] transition-all min-h-[110px]"
        >
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-semibold uppercase tracking-wider text-white/90">
              AGUARDANDO RESPOSTA
            </span>
            <span class="size-6 rounded-lg bg-white/20 flex items-center justify-center text-white">
              <span class="i-lucide-sparkles size-3.5" />
            </span>
          </div>
          <div class="text-2xl font-bold my-1 text-white">
            {{ metrics.conversation_metrics?.unattended || 0 }}
          </div>
          <div class="text-[11px] text-white/90 font-medium">
            Novo contato pelo agente
          </div>
        </div>
        <!-- 2) MINHAS CONVERSAS (Gradiente Dark Navy Blue) -->
        <div
          @click="goToConversations('me')"
          class="rounded-xl p-4 bg-gradient-to-br from-[#2781F6] via-[#1c6edb] to-[#1557ad]  hover:brightness-105 shadow-sm shadow-blue-500/20 text-white shadow-sm flex flex-col justify-between cursor-pointer hover:shadow-md hover:scale-[1.01] transition-all min-h-[110px]"
        >
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-semibold uppercase tracking-wider text-white/90">
              MINHAS CONVERSAS
            </span>
            <span class="size-6 rounded-lg bg-white/20 flex items-center justify-center text-white">
              <span class="i-lucide-user size-3.5" />
            </span>
          </div>
          <div class="text-2xl font-bold my-1 text-white">
            {{ metrics.conversation_metrics?.mine || 0 }}
          </div>
          <div class="text-[11px] text-white/90 font-medium">
            Atividades a você
          </div>
        </div>
        <!-- 3) NÃO ATRIBUÍDAS (Gradiente Dark Navy Blue) -->
        <div
          @click="goToConversations('unassigned')"
          class="rounded-xl p-4 bg-gradient-to-br from-[#2781F6] via-[#1c6edb] to-[#1557ad]  hover:brightness-105 shadow-sm shadow-blue-500/20 text-white shadow-sm flex flex-col justify-between cursor-pointer hover:shadow-md hover:scale-[1.01] transition-all min-h-[110px]"
        >
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-semibold uppercase tracking-wider text-white/90">
              NÃO ATRIBUÍDAS
            </span>
            <span class="size-6 rounded-lg bg-white/20 flex items-center justify-center text-white">
              <span class="i-lucide-users size-3.5" />
            </span>
          </div>
          <div class="text-2xl font-bold my-1 text-white">
            {{ metrics.conversation_metrics?.unassigned || 0 }}
          </div>
          <div class="text-[11px] text-white/90 font-medium">
            Para pegar e atender
          </div>
        </div>
        <!-- 4) TOTAL ABERTAS (Card Claro) -->
        <div
          @click="goToConversations('all')"
          class="rounded-xl p-4 bg-white dark:bg-[#141518] border border-slate-200/90 dark:border-[#26282d] text-slate-900 dark:text-white shadow-xs flex flex-col justify-between cursor-pointer hover:border-slate-300 dark:hover:border-slate-700 transition-all min-h-[110px]"
        >
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
              TOTAL ABERTAS
            </span>
            <span class="size-6 rounded-lg bg-slate-100 dark:bg-[#18191f] flex items-center justify-center text-slate-600 dark:text-white/90">
              <span class="i-lucide-inbox size-3.5" />
            </span>
          </div>
          <div class="text-2xl font-bold my-1 text-slate-900 dark:text-white">
            {{ metrics.conversation_metrics?.all_open || 0 }}
          </div>
          <div class="text-[11px] text-slate-500 dark:text-slate-400 font-medium">
            Conversas em aberto
          </div>
        </div>
        <!-- 5) RESOLVIDAS HOJE (Card Claro) -->
        <div
          @click="goToConversations('all')"
          class="rounded-xl p-4 bg-white dark:bg-[#141518] border border-slate-200/90 dark:border-[#26282d] text-slate-900 dark:text-white shadow-xs flex flex-col justify-between cursor-pointer hover:border-slate-300 dark:hover:border-slate-700 transition-all min-h-[110px]"
        >
          <div class="flex items-center justify-between">
            <span class="text-[10px] font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
              RESOLVIDAS HOJE
            </span>
            <span class="size-6 rounded-lg bg-slate-100 dark:bg-[#18191f] flex items-center justify-center text-emerald-600 dark:text-emerald-400">
              <span class="i-lucide-check-circle size-3.5" />
            </span>
          </div>
          <div class="text-2xl font-bold my-1 text-slate-900 dark:text-white">
            {{ metrics.conversation_metrics?.resolved_today || 0 }}
          </div>
          <div class="text-[11px] text-slate-500 dark:text-slate-400 font-medium">
            Atendimentos concluídos
          </div>
        </div>
      </div>
    </div>
    <!-- 4. GRID COM 2 CARDS: PRAZOS DA SEMANA & CENTRAL DE INTIMAÇÕES -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <!-- Card da Esquerda: Publicações & Prazos da Semana -->
      <div class="bg-white dark:bg-[#141518] border border-slate-200/90 dark:border-[#26282d]/90 rounded-2xl p-5 shadow-xs flex flex-col justify-between space-y-4">
        <!-- Header -->
        <div class="flex items-start justify-between gap-2">
          <div class="flex items-center gap-2.5">
            <span class="p-2 rounded-xl bg-blue-50 dark:bg-blue-950/60 text-[#2781F6] dark:text-[#60a5fa] border border-blue-200/60 dark:border-blue-900/60">
              <span class="i-lucide-calendar-check size-4" />
            </span>
            <div>
              <h3 class="text-sm font-bold text-slate-900 dark:text-white">
                Publicações & Prazos da Semana
              </h3>
              <p class="text-[11px] text-slate-500 dark:text-slate-400">
                Quantidade de prazos para cumprir de segunda à domingo
              </p>
            </div>
          </div>
          <router-link
            :to="{ name: 'tarefas_dashboard' }"
            class="text-xs font-bold text-[#2781F6] dark:text-[#60a5fa] hover:underline flex items-center gap-1 shrink-0"
          >
            <span>Ver Tarefas</span>
            <span class="i-lucide-arrow-right size-3" />
          </router-link>
        </div>
        <!-- Gráfico de Barras dos 7 Dias -->
        <div class="grid grid-cols-7 gap-2.5 items-end h-32 px-2 pt-2">
          <div
            v-for="d in weeklyTarefasList"
            :key="d.date"
            class="flex flex-col items-center justify-end h-full group cursor-pointer"
            :title="`${d.day_name}: ${d.count} prazos`"
          >
            <!-- Número acima da barra -->
            <span
              class="text-xs font-bold mb-1.5 transition-colors"
              :class="Number(d.count) > 0 ? 'text-[#2781F6] dark:text-[#60a5fa] font-black text-sm' : 'text-slate-400 dark:text-slate-600'"
            >
              {{ d.count }}
            </span>
            <!-- Track do Gráfico (Fundo da coluna) -->
            <div class="w-full max-w-[34px] h-20 bg-slate-100 dark:bg-[#18191f] rounded-xl flex items-end justify-center p-1 border border-slate-200/50 dark:border-slate-700/50">
              <!-- Barra de Preenchimento Colorida em Azul -->
              <div
                v-if="Number(d.count) > 0"
                class="w-full rounded-lg transition-all duration-500 shadow-sm"
                :style="{
                  height: `${Math.max((Number(d.count) / Math.max(maxTarefasCount, 2)) * 100, 35)}%`,
                  minHeight: '16px',
                  backgroundColor: '#2781F6'
                }"
              />
            </div>
            <!-- Dia da semana -->
            <span
              class="text-xs font-semibold mt-2"
              :class="d.is_today ? 'text-[#2781F6] dark:text-[#60a5fa] font-black underline decoration-2 underline-offset-4' : 'text-slate-500 dark:text-slate-400'"
            >
              {{ d.day_name }}
            </span>
          </div>
        </div>
        <!-- 4 Sub-Boxes Inferiores -->
        <div class="grid grid-cols-4 gap-2 pt-2 border-t border-slate-100 dark:border-[#26282d]">
          <div class="p-2.5 rounded-xl bg-slate-50/80 dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700/60 text-center">
            <div class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">ATRASADOS</div>
            <div class="text-base font-bold text-rose-600 dark:text-rose-400 mt-0.5">
              {{ metrics.tarefas_metrics?.overdue || 1 }}
            </div>
          </div>
          <div class="p-2.5 rounded-xl bg-slate-50/80 dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700/60 text-center">
            <div class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">PARA HOJE</div>
            <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
              {{ metrics.tarefas_metrics?.today || 0 }}
            </div>
          </div>
          <div class="p-2.5 rounded-xl bg-slate-50/80 dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700/60 text-center">
            <div class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">HOJE / 7 DIAS</div>
            <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
              {{ metrics.tarefas_metrics?.next_7_days || 1 }}
            </div>
          </div>
          <div class="p-2.5 rounded-xl bg-slate-50/80 dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700/60 text-center">
            <div class="text-[10px] font-bold text-slate-500 uppercase tracking-wider">NÃO CONCLUÍDOS</div>
            <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
              {{ metrics.tarefas_metrics?.uncompleted || 3 }}
            </div>
          </div>
        </div>
      </div>
      <!-- Card da Direita: Central de Intimações & DJEN -->
      <div class="bg-white dark:bg-[#141518] border border-slate-200/90 dark:border-[#26282d]/90 rounded-2xl p-5 shadow-xs flex flex-col justify-between space-y-4">
        <!-- Header -->
        <div class="flex items-center gap-2.5">
          <span class="p-2 rounded-xl bg-blue-50 dark:bg-blue-950/60 text-[#2781F6] dark:text-[#60a5fa] border border-blue-200/60 dark:border-blue-900/60">
            <span class="i-lucide-scale size-4" />
          </span>
          <div>
            <h3 class="text-sm font-bold text-slate-900 dark:text-white">
              Central de Intimações & DJEN
            </h3>
            <p class="text-[11px] text-slate-500 dark:text-slate-400">
              Monitoramento diário dos Diários Oficiais e intimações
            </p>
          </div>
        </div>
        <!-- 4 KPI Boxes -->
        <div class="grid grid-cols-4 gap-2">
          <div class="p-2.5 rounded-xl bg-slate-50/80 dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700/60">
            <div class="text-[10px] font-bold text-slate-500 uppercase">HOJE</div>
            <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
              {{ metrics.intimacoes_metrics?.today || 5 }}
            </div>
            <div class="text-[9px] text-slate-400 truncate">Fascículos lidas hoje</div>
          </div>
          <div class="p-2.5 rounded-xl bg-slate-50/80 dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700/60">
            <div class="text-[10px] font-bold text-slate-500 uppercase">ONTEM</div>
            <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
              {{ metrics.intimacoes_metrics?.yesterday || 10 }}
            </div>
            <div class="text-[9px] text-slate-400 truncate">Total de fascículos</div>
          </div>
          <!-- Highlighted Card: ESTA SEMANA -->
          <div class="p-2.5 rounded-xl bg-[#EBF5FF]/50 dark:bg-[#0B2545]/40 border-2 border-[#2781F6] shadow-2xs">
            <div class="text-[10px] font-black text-[#2781F6] dark:text-[#60a5fa] uppercase">ESTA SEMANA</div>
            <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
              {{ metrics.intimacoes_metrics?.this_week || 17 }}
            </div>
            <div class="text-[9px] text-blue-600/80 dark:text-blue-400/80 truncate">Total de fascículos</div>
          </div>
          <div class="p-2.5 rounded-xl bg-slate-50/80 dark:bg-[#18191f] border border-slate-200/60 dark:border-slate-700/60">
            <div class="text-[10px] font-bold text-slate-500 uppercase">NÃO LIDAS</div>
            <div class="text-base font-bold text-slate-900 dark:text-white mt-0.5">
              {{ metrics.intimacoes_metrics?.unread || 8 }}
            </div>
            <div class="text-[9px] text-slate-400 truncate">Com prazo hoje</div>
          </div>
        </div>
        <!-- Gráfico Suave de Linha/Área SVG -->
        <div class="space-y-1 pt-1">
          <div class="text-[11px] font-bold text-slate-600 dark:text-slate-400">
            Volume diário de publicações recebidas:
          </div>
          <div class="w-full relative pt-2">
            <svg viewBox="0 0 700 120" class="w-full h-24 overflow-visible" preserveAspectRatio="none">
              <defs>
                <linearGradient id="blueAreaGrad" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#2781F6" stop-opacity="0.35" />
                  <stop offset="100%" stop-color="#2781F6" stop-opacity="0.0" />
                </linearGradient>
              </defs>
              <!-- Área Preenchida com Gradiente -->
              <polygon
                :points="`50,100 ${intimacoesPointsString} 650,100`"
                fill="url(#blueAreaGrad)"
              />
              <!-- Linha Conectora Azul -->
              <polyline
                :points="intimacoesPointsString"
                fill="none"
                stroke="#2781F6"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <!-- Pontos e Valores nos Dias -->
              <g v-for="(p, pIdx) in intimacoesChartPoints" :key="pIdx">
                <!-- Valor acima do ponto -->
                <text
                  :x="p.x"
                  :y="p.y - 10"
                  text-anchor="middle"
                  class="text-[12px] font-bold fill-slate-700 dark:fill-slate-300"
                >
                  {{ p.val }}
                </text>
                <!-- Ponto Circular com borda azul e fundo branco -->
                <circle
                  :cx="p.x"
                  :cy="p.y"
                  r="4.5"
                  fill="#ffffff"
                  stroke="#2781F6"
                  stroke-width="2.5"
                />
              </g>
            </svg>
            <!-- Rótulos dos Dias da Semana -->
            <div class="grid grid-cols-7 text-center text-xs font-semibold text-slate-500 dark:text-slate-400 pt-1">
              <span
                v-for="d in metrics.intimacoes_metrics?.weekly_distribution || defaultDays"
                :key="d.day_name"
                :class="d.is_today ? 'text-[#2781F6] dark:text-[#60a5fa] font-bold underline decoration-2 underline-offset-4' : ''"
              >
                {{ d.day_name }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 5. SEÇÃO INFERIOR: PRODUTIVIDADE & DESEMPENHO DOS AGENTES -->
    <div class="bg-white dark:bg-[#141518] border border-slate-200/90 dark:border-[#26282d]/90 rounded-2xl p-5 shadow-xs flex flex-col lg:flex-row items-stretch justify-between gap-6">
      <!-- Esquerda: 4 Métricas com Sparklines em Azul Vibrante -->
      <div class="flex-1 space-y-4">
        <div>
          <h3 class="text-sm font-bold text-slate-900 dark:text-white flex items-center gap-2">
            <span class="i-lucide-activity text-[#2781F6] dark:text-[#60a5fa] size-4" />
            <span>Produtividade & Desempenho dos Agentes (Últimos 7 Dias)</span>
          </h3>
          <p class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">
            Volume de conversas iniciadas, mensagens e ocupação da equipe
          </p>
        </div>
        <div class="grid grid-cols-2 sm:grid-cols-4 gap-4">
          <!-- 1) Conversas Iniciadas -->
          <div class="space-y-1.5">
            <div class="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 font-medium">
              <span class="i-lucide-message-square size-3.5 text-[#2781F6] dark:text-[#60a5fa]" />
              <span class="truncate">Conversas Iniciadas</span>
            </div>
            <div class="flex items-baseline gap-2">
              <span class="text-xl font-bold text-slate-900 dark:text-white">
                {{ metrics.reports_metrics?.conversations_last_7_days || 43 }}
              </span>
              <span class="text-[10px] font-bold text-emerald-600 bg-emerald-50 dark:bg-emerald-950/50 border border-emerald-500/20 px-1.5 py-0.5 rounded-md flex items-center gap-0.5">
                <span>↑</span> 12%
              </span>
            </div>
            <!-- Sparkline SVG Azul Vibrante com Gradiente de Área -->
            <svg viewBox="0 0 100 28" class="w-full h-7 overflow-visible">
              <defs>
                <linearGradient id="sparkGrad1" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#2781F6" stop-opacity="0.3" />
                  <stop offset="100%" stop-color="#2781F6" stop-opacity="0.0" />
                </linearGradient>
              </defs>
              <polygon points="0,28 0,20 25,10 50,16 75,8 100,6 100,28" fill="url(#sparkGrad1)" />
              <path d="M0,20 Q25,10 50,16 T100,6" fill="none" stroke="#3B82F6" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>
          <!-- 2) Mensagens Enviadas -->
          <div class="space-y-1.5">
            <div class="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 font-medium">
              <span class="i-lucide-send size-3.5 text-[#2781F6] dark:text-[#60a5fa]" />
              <span class="truncate">Mensagens Enviadas</span>
            </div>
            <div class="flex items-baseline gap-2">
              <span class="text-xl font-bold text-slate-900 dark:text-white">
                {{ formatNumber(metrics.reports_metrics?.messages_last_7_days || 4921) }}
              </span>
              <span class="text-[10px] font-bold text-emerald-600 bg-emerald-50 dark:bg-emerald-950/50 border border-emerald-500/20 px-1.5 py-0.5 rounded-md flex items-center gap-0.5">
                <span>↑</span> 8%
              </span>
            </div>
            <!-- Sparkline SVG Azul Vibrante com Gradiente de Área -->
            <svg viewBox="0 0 100 28" class="w-full h-7 overflow-visible">
              <defs>
                <linearGradient id="sparkGrad2" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#2781F6" stop-opacity="0.3" />
                  <stop offset="100%" stop-color="#2781F6" stop-opacity="0.0" />
                </linearGradient>
              </defs>
              <polygon points="0,28 0,22 20,14 40,18 70,8 100,4 100,28" fill="url(#sparkGrad2)" />
              <path d="M0,22 Q20,14 40,18 T70,8 T100,4" fill="none" stroke="#3B82F6" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>
          <!-- 3) Tempo Médio Resposta -->
          <div class="space-y-1.5">
            <div class="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 font-medium">
              <span class="i-lucide-clock size-3.5 text-[#2781F6] dark:text-[#60a5fa]" />
              <span class="truncate">Tempo Médio Resposta</span>
            </div>
            <div class="flex items-baseline gap-2">
              <span class="text-xl font-bold text-slate-900 dark:text-white">
                {{ metrics.reports_metrics?.avg_response_time || '02:18' }}
              </span>
              <span class="text-[10px] font-bold text-emerald-600 bg-emerald-50 dark:bg-emerald-950/50 border border-emerald-500/20 px-1.5 py-0.5 rounded-md flex items-center gap-0.5">
                <span>↓</span> 15%
              </span>
            </div>
            <!-- Sparkline SVG Azul Vibrante com Gradiente de Área -->
            <svg viewBox="0 0 100 28" class="w-full h-7 overflow-visible">
              <defs>
                <linearGradient id="sparkGrad3" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#2781F6" stop-opacity="0.3" />
                  <stop offset="100%" stop-color="#2781F6" stop-opacity="0.0" />
                </linearGradient>
              </defs>
              <polygon points="0,28 0,10 30,18 60,12 100,22 100,28" fill="url(#sparkGrad3)" />
              <path d="M0,10 Q30,18 60,12 T100,22" fill="none" stroke="#3B82F6" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>
          <!-- 4) Ocupação da Equipe -->
          <div class="space-y-1.5">
            <div class="flex items-center gap-1.5 text-xs text-slate-500 dark:text-slate-400 font-medium">
              <span class="i-lucide-users size-3.5 text-[#2781F6] dark:text-[#60a5fa]" />
              <span class="truncate">Ocupação da Equipe</span>
            </div>
            <div class="flex items-baseline gap-2">
              <span class="text-xl font-bold text-slate-900 dark:text-white">
                {{ metrics.reports_metrics?.team_occupancy || '72%' }}
              </span>
              <span class="text-[10px] font-bold text-emerald-600 bg-emerald-50 dark:bg-emerald-950/50 border border-emerald-500/20 px-1.5 py-0.5 rounded-md flex items-center gap-0.5">
                <span>↑</span> 6%
              </span>
            </div>
            <!-- Sparkline SVG Azul Vibrante com Gradiente de Área -->
            <svg viewBox="0 0 100 28" class="w-full h-7 overflow-visible">
              <defs>
                <linearGradient id="sparkGrad4" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stop-color="#2781F6" stop-opacity="0.3" />
                  <stop offset="100%" stop-color="#2781F6" stop-opacity="0.0" />
                </linearGradient>
              </defs>
              <polygon points="0,28 0,18 35,8 70,14 100,6 100,28" fill="url(#sparkGrad4)" />
              <path d="M0,18 Q35,8 70,14 T100,6" fill="none" stroke="#3B82F6" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>
        </div>
      </div>
      <!-- Direita: Desempenho Geral + Circular Donut Ring Colorido em Azul Neon/Royal -->
      <div class="w-full lg:w-56 border-t lg:border-t-0 lg:border-l border-slate-100 dark:border-[#26282d] lg:pl-6 flex items-center justify-between lg:justify-center gap-6">
        <div>
          <div class="text-xs font-bold text-slate-900 dark:text-white">Desempenho Geral</div>
          <div class="text-[11px] text-slate-400 font-medium">Muito bom</div>
        </div>
        <!-- Donut Chart 84% com Anel Azul Vibrante -->
        <div class="relative size-20 shrink-0 flex items-center justify-center">
          <svg viewBox="0 0 36 36" class="size-full -rotate-90 overflow-visible">
            <!-- Anel de Fundo (Track sutil) -->
            <path
              stroke="#1E293B"
              stroke-width="3.2"
              fill="none"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
              class="dark:stroke-[#1f2026] stroke-slate-100"
            />
            <!-- Arco de Progresso Ativo em Azul Royal (#2563EB) -->
            <path
              stroke="#2781F6"
              stroke-dasharray="84, 100"
              stroke-linecap="round"
              stroke-width="3.2"
              fill="none"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <span class="absolute text-sm font-black text-slate-900 dark:text-white tracking-tight">
            {{ metrics.reports_metrics?.overall_performance || 84 }}%
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import HomeDashboardAPI from 'dashboard/api/homeDashboard';
import SdrAnalyticsAPI from 'dashboard/api/sdrAnalytics';
const router = useRouter();
const isLoading = ref(false);
const selectedFunnelKey = ref('');
const sdrWidget = ref({});
const defaultDays = [
  { day_name: 'Seg', is_today: false, count: 0 },
  { day_name: 'Ter', is_today: false, count: 0 },
  { day_name: 'Qua', is_today: true, count: 0 },
  { day_name: 'Qui', is_today: false, count: 0 },
  { day_name: 'Sex', is_today: false, count: 0 },
  { day_name: 'Sáb', is_today: false, count: 0 },
  { day_name: 'Dom', is_today: false, count: 0 },
];
const metrics = ref({
  user_name: 'Vanderson',
  kanban_funnels: [],
  conversation_metrics: {},
  tarefas_metrics: { weekly_distribution: [] },
  intimacoes_metrics: { weekly_distribution: [] },
  reports_metrics: {},
  server_time: ''
});
const userInitials = computed(() => {
  const name = metrics.value.user_name || 'CR';
  return name.substring(0, 2).toUpperCase();
});
const formattedBrasiliaDateTime = computed(() => {
  return new Intl.DateTimeFormat('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date());
});
const greetingText = computed(() => {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return 'Bom dia';
  if (hour >= 12 && hour < 18) return 'Boa tarde';
  return 'Boa noite';
});
const activeFunnel = computed(() => {
  if (!metrics.value.kanban_funnels?.length) return null;
  if (selectedFunnelKey.value) {
    return metrics.value.kanban_funnels.find(f => f.attribute_key === selectedFunnelKey.value) || metrics.value.kanban_funnels[0];
  }
  return metrics.value.kanban_funnels[0];
});
const activeFunnelStages = computed(() => {
  return activeFunnel.value?.stages || [];
});
const weeklyTarefasList = computed(() => {
  return metrics.value.tarefas_metrics?.weekly_distribution?.length
    ? metrics.value.tarefas_metrics.weekly_distribution
    : defaultDays;
});
const maxTarefasCount = computed(() => {
  const arr = weeklyTarefasList.value;
  const max = Math.max(...arr.map(d => Number(d.count) || 0), 1);
  return max;
});
const getStageIcon = (idx) => {
  const icons = [
    'i-lucide-inbox',
    'i-lucide-file-text',
    'i-lucide-file-signature',
    'i-lucide-shield-check',
    'i-lucide-folder-check',
    'i-lucide-send',
    'i-lucide-calendar-clock'
  ];
  return icons[idx % icons.length];
};
const formatNumber = (val) => {
  if (!val) return '0';
  return new Intl.NumberFormat('pt-BR').format(val);
};
// Cálculo dos pontos do gráfico SVG de Intimações
const intimacoesChartPoints = computed(() => {
  const dist = metrics.value.intimacoes_metrics?.weekly_distribution || [];
  const mockCounts = [2, 10, 5, 0, 0, 0, 0];
  const maxVal = Math.max(...dist.map(d => Number(d.count) || 0), 10);
  const xs = [50, 150, 250, 350, 450, 550, 650];
  return xs.map((x, i) => {
    const val = dist[i] !== undefined ? Number(dist[i].count) : mockCounts[i];
    // Map value to Y coordinate (0 count -> Y=100, maxVal -> Y=20)
    const y = 100 - (val / (maxVal || 1)) * 80;
    return { x, y: Math.max(Math.min(y, 100), 20), val };
  });
});
const intimacoesPointsString = computed(() => {
  return intimacoesChartPoints.value.map(p => `${p.x},${p.y}`).join(' ');
});
const fetchSdrWidget = async () => {
  try {
    const res = await SdrAnalyticsAPI.getSummaryWidget();
    if (res?.data) {
      sdrWidget.value = res.data;
    }
  } catch (error) {
    console.error('Failed to fetch SDR widget:', error);
  }
};
const fetchMetrics = async () => {
  isLoading.value = true;
  try {
    const response = await HomeDashboardAPI.getMetrics();
    if (response?.data) {
      metrics.value = response.data;
      if (!selectedFunnelKey.value && response.data.kanban_funnels?.length) {
        selectedFunnelKey.value = response.data.kanban_funnels[0].attribute_key;
      }
    }
  } catch (error) {
    console.error('Failed to fetch home dashboard metrics:', error);
  } finally {
    isLoading.value = false;
  }
};
const goToKanbanStage = (attributeKey, stageName) => {
  router.push({
    name: 'kanban_board',
    params: { attributeKey: attributeKey || 'servidor' },
    query: { stage: stageName }
  });
};
const goToConversations = (tabType) => {
  router.push({
    name: 'inbox_conversation',
    params: { conversationType: tabType }
  });
};
onMounted(() => {
  fetchMetrics();
  fetchSdrWidget();
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap");

.home-dashboard-root {
  font-family: "Inter", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.stage-card {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
